import styled from 'styled-components';
import RightArrowIcon from '../../assets/images/arrow-right-coral-icon.svg';

const ArrowRightCoralIcon = styled.span`
  background: url(\"${RightArrowIcon}\") no-repeat left center;
  background-size: 18px 18px;
  display: block;
  position: relative;
  width: 20px;
`;

export default ArrowRightCoralIcon;
